import React, { useEffect } from "react";
import { getCustomers } from '../../../slices/customers'
import { useDispatch } from 'react-redux';
import { CustomersListTable } from "../../../components/table/table_customerslist";
import { API_DEFAULT_PAGE_SIZE } from '../../../const';

const CustomerList = ({ callBack }) => {

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getCustomers([{"limit":API_DEFAULT_PAGE_SIZE}]))
    }, [])

    return (
        <div className="container-fluid customers-component">
            <div className="row">
                <div className="col">
                    <h1 className="title">{gettext('Customers')}</h1>
                </div>
            </div>

            <CustomersListTable callBack={callBack} />
        </div>

    )

}

export default CustomerList